import { render, staticRenderFns } from "./DeleteOrganisationModal.vue?vue&type=template&id=75063e70"
import script from "./DeleteOrganisationModal.vue?vue&type=script&lang=js"
export * from "./DeleteOrganisationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75063e70')) {
      api.createRecord('75063e70', component.options)
    } else {
      api.reload('75063e70', component.options)
    }
    module.hot.accept("./DeleteOrganisationModal.vue?vue&type=template&id=75063e70", function () {
      api.rerender('75063e70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/admin/DeleteOrganisationModal.vue"
export default component.exports